import { Spinner } from 'modules/spinners';

export default function MapOverlay() {
    return (
        <div className="MapOverlay">
            <Spinner className="MapOverlay-spinner" />
        </div>
    );
}
